import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap-5';
import Select from 'react-select';
import './index.scss';

export default function JobTitlesSelect({ jobTitles, userJobTitles }) {
  const [selectedJobTitles, setSelectedJobTitles] = useState(userJobTitles.map(jt => jt.jobTitleId));
  const [tooManyTitles, setTooManyTitles] = useState(false);
  const titlesErrorTimeout = useRef();
  const baseName = 'user[job_titles_users_attributes]';
  const persistedJobTitles = userJobTitles.map(jt => jt.jobTitleId);
  const newJobTitleIds = selectedJobTitles.filter(jt => !persistedJobTitles.includes(jt));

  const changeSelectedJobTitles = (selectedOptions) => {
    const newOptionsList = selectedOptions.map(option => option.value);
    clearTimeout(titlesErrorTimeout.current);
    if (newOptionsList.length <= 3) {
      setSelectedJobTitles(newOptionsList);
      setTooManyTitles(false);
    } else {
      setTooManyTitles(true);
      titlesErrorTimeout.current = setTimeout(() => {
        setTooManyTitles(false);
      }, 3000);
    }
  };

  return (
    <React.Fragment>
      <label className="">Job Titles</label>
      {tooManyTitles && (
        <p className="text-danger">You can only select up to 3 job titles</p>
      )}
      <Row className="form-group">
        <Col md={12}>
          <Select
            classNamePrefix="react-select-buildout"
            isMulti
            options={jobTitles}
            value={jobTitles.filter(jt => selectedJobTitles.includes(jt.value))}
            onChange={selectedOptions => changeSelectedJobTitles(selectedOptions)}
          />
        </Col>
      </Row>

      {userJobTitles.map((userJobTitle, index) => (
        <React.Fragment key={userJobTitle.id}>
          <input name={`${baseName}[${index}][id]`} type="hidden" value={userJobTitle.id}/>
          <input
            name={`${baseName}[${index}][job_title_id]`}
            type="hidden"
            value={userJobTitle.jobTitleId}
          />
          <input
            name={`${baseName}[${index}][_destroy]`}
            type="hidden"
            value={!selectedJobTitles.includes(userJobTitle.jobTitleId)}
          />
        </React.Fragment>
      ))}

      {newJobTitleIds.map((jobTitleId, i) => {
        const index = i + userJobTitles.length;

        return (
          <input
            key={jobTitleId}
            name={`${baseName}[${index}][job_title_id]`}
            type="hidden"
            value={jobTitleId}
          />
        );
      })}
    </React.Fragment>
  );
}

JobTitlesSelect.propTypes = {
  jobTitles: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string
  })).isRequired,
  userJobTitles: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    jobTitleId: PropTypes.number
  })).isRequired
};
